var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "preview-content" }, [
    _c("div", { staticClass: "preview-detail" }, [
      _c(
        "div",
        { staticClass: "preview-title" },
        [
          _c(
            "el-button",
            {
              staticClass: "title-btn",
              staticStyle: { width: "68px", height: "32px" },
              attrs: { round: "" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v("返回")]
          ),
          _c("span", [_vm._v("公告详情")]),
          _c("div", { staticClass: "preview-date" }),
        ],
        1
      ),
      _c("div", { staticClass: "line" }),
      !_vm.offShelf
        ? _c("div", { staticClass: "preDetail" }, [
            _c("div", { staticClass: "content-wrapper" }, [
              _c("div", { staticClass: "preview-meta" }, [
                _vm.form.title
                  ? _c("div", { staticClass: "meta-item" }, [
                      _c("span", { staticClass: "meta-value1" }, [
                        _vm._v(_vm._s(_vm.form.title)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.form.categoryName || _vm.form.author
                  ? _c("div", { staticClass: "meta-item" }, [
                      _c("span", { staticClass: "meta-value" }, [
                        _vm._v(_vm._s(_vm.form.author || "")),
                      ]),
                      _c("span", { staticStyle: { padding: "0 10px" } }, [
                        _vm._v("|"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "meta-value",
                          staticStyle: { color: "#409EFF" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                "#" + (_vm.form.categoryName || "") + "#"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "meta-item" }, [
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.form.publishTime)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "preview-body" }, [
                _c("div", {
                  staticClass: "preview-html",
                  domProps: { innerHTML: _vm._s(_vm.form.content) },
                }),
              ]),
            ]),
            _vm.form.attachmentList && _vm.form.attachmentList.length
              ? _c(
                  "div",
                  { staticClass: "preview-attachments" },
                  [
                    _c("h3", [_vm._v("附件")]),
                    _c("approval-attachment-list", {
                      attrs: { files: _vm.form.attachmentList },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "preview-read" }, [
              _c("span", [
                _vm._v("共" + _vm._s(_vm.form.readCount || 0) + "人已读"),
              ]),
              _c("span", { staticStyle: { padding: "0 10px" } }, [_vm._v("|")]),
              _vm.form.readStatus === "3"
                ? _c(
                    "span",
                    [
                      _vm._l(_vm.form.confirmList, function (item, index) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(item) +
                              _vm._s(
                                index < _vm.form.confirmList.length - 1
                                  ? "、"
                                  : ""
                              ) +
                              " "
                          ),
                        ]
                      }),
                      _vm._v(
                        " 等" + _vm._s(_vm.form.confirmCount) + "人已确认 "
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "preDetail-offShelf" },
            [
              _c("img", {
                staticStyle: { display: "block", margin: "160px auto 0" },
                attrs: {
                  src: require("@/assets/img/announcement/img_wugonggao.png"),
                  alt: "",
                },
              }),
              _c("div", [_vm._v("公告已撤回 / 公告已下架")]),
              _c(
                "el-button",
                {
                  staticClass: "btn-footer1",
                  attrs: { type: "success", plain: "", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
    ]),
    !_vm.offShelf
      ? _c(
          "div",
          { staticClass: "preview-btns" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn-footer",
                attrs: { type: "info", plain: "", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v("返回")]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn-footer",
                attrs: {
                  type: "primary",
                  size: "small",
                  disabled: _vm.form.readStatus === "3",
                  loading: _vm.confirmLoading,
                },
                on: { click: _vm.getConfirm },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.form.readStatus === "3" ? "已确认" : "确认") +
                    " "
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }